class DisplayTemplateController {
  constructor($scope, APIConfig, appModel, utils) {
    "ngInject";
    this.$scope = $scope;
    this.APIConfig = APIConfig;
    this.appModel = appModel;
    this.utils = utils;
  }

  $onInit() {
    this.$scope.$watch('vm.template', template => {
      if (template) {
        this.templateStyle = this.getTemplateStyle(template);
      }
    });

    this.$scope.$watch('vm.templateBlocks', templateBlocks => {
      if (templateBlocks) {
        /* Sort the template blocks so that alert boxes are displayed on top. */
      }
    });
  }

  getTemplateStyle(template) {
    const width = template.screenresolution.width;
    const height = template.screenresolution.height;
    return {
      width: `${width}px`,
      height: `${height}px`
    }
  }

  get alertActive() {
    
  }
}

export default DisplayTemplateController;



// WEBPACK FOOTER //
// ./client/app/components/displayTemplate/displayTemplate.controller.js